import { render } from "./RefuseDialog.vue?vue&type=template&id=6b781c9e"
import script from "./RefuseDialog.vue?vue&type=script&lang=js"
export * from "./RefuseDialog.vue?vue&type=script&lang=js"

import "./RefuseDialog.vue?vue&type=style&index=0&id=6b781c9e&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__